<template>
  <title>Bell</title>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3805 14.2348C13.9593 14.0475 15.4817 13.6763 16.9258 13.1432C15.7284 11.8142 14.9997 10.0547 14.9997 8.125V7.54099C14.9998 7.52734 14.9998 7.51368 14.9998 7.5C14.9998 4.73858 12.7612 2.5 9.99982 2.5C7.23839 2.5 4.99982 4.73858 4.99982 7.5L4.99965 8.125C4.99965 10.0547 4.27088 11.8142 3.07355 13.1432C4.51765 13.6763 6.04018 14.0475 7.6191 14.2348M12.3805 14.2348C11.5998 14.3274 10.8053 14.375 9.99965 14.375C9.19412 14.375 8.39972 14.3274 7.6191 14.2348M12.3805 14.2348C12.458 14.4759 12.4998 14.7331 12.4998 15C12.4998 16.3807 11.3805 17.5 9.99982 17.5C8.61911 17.5 7.49982 16.3807 7.49982 15C7.49982 14.7331 7.54164 14.476 7.6191 14.2348M2.60352 6.25C2.84292 4.82303 3.48526 3.5327 4.40955 2.5M15.5901 2.5C16.5144 3.5327 17.1567 4.82303 17.3961 6.25"
      stroke="#0D0E0F"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg path {
  stroke: var(--color-icon-primary);
}
</style>
